import styled from 'styled-components'

const H6 = styled.h6`
  color: ${props => props.theme.colors.darkGray};
  font-weight: 600;
`

export default H6
